import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { goToPage, reportDWH } from '../../ServiceAppointmentBlockSlice';
import {getTimeSlotsAsync,} from '../../ServiceAppointmentAsyncthunk';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import ExclamationMark from './images/exclamationMark.svg';
import CreditCard from './images/credit_card.svg';
import PowerSupplyIcon from '../../images/power_supply.svg';
import lightIcon from '../../images/icon-light.svg';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../../../Config';
import { buildUrlAndOpenSameWindow } from '../../../../../utilities/StringHelpers/StringHelpers';


const ErrorPage = (props) => {

    let title = null;
    let subTitle = null;
    let text = null;
    let icon = 'error-icon';
    let dateLinks = [];
    let callBackButtons = [];
    let isDisplayWhatsAppIcon = false;
    let btnText = 'בואו נתקדם';
    let isPurpleButton = false;
    let imgUrl = '';
    let callbackTitle = '';
    let id = '';
    let alert = '';
    const SUPPORT_PHONE = window.Config.technicalSupportPhone;

    switch (props.typePage) {
        case 'NO_INTERNET_SERVICE_PAGE':
            imgUrl = ExclamationMark;
            title = <> שמנו לב שאין לכם שירות אינטרנט ב{window.Config.brand_Name_HE}</>;
            subTitle = <> יכול להיות שנרשמתם עם פרטים אחרים? שווה לנסות להתחבר שוב</>;
            dateLinks = [{text: 'לחצו כאן להצטרפות לשירות' , link: Config.internetSaleLink}];
            btnText = 'לאיזור האישי';
            id = props.typePage;
            break;
        case 'ACTION_CANNOT_BE_COMPLETED_PAGE_2_1':
            imgUrl = CreditCard;
            title = <>מצטערים, לא ניתן להשלים את הפעולה!</>;
            if (props.subscriber.hasDebt && props.subscriber.hasPaymentMethodIssue) {
                subTitle = <>לפני שנמשיך בתהליך, עליך לעדכן את אמצעי<br></br> התשלום שלך {window.Config.brand_Name_HE} ולשלם את החוב.</>;
                dateLinks.push({text:'לתשלום חוב', link: Config.payDebtLink});
                dateLinks.push({text:'לעדכון אמצעי תשלום', link: Config.updatePaymentMethodLink});
            } else if (props.subscriber.hasDebt && !props.subscriber.hasPaymentMethodIssue) {
                dateLinks.push({text:'לתשלום חוב', link: Config.payDebtLink});
                subTitle = <>לפני שנמשיך בתהליך, עליך לשלם את החוב</>;
            } else if (!props.subscriber.hasDebt && props.subscriber.hasPaymentMethodIssue) {
                dateLinks.push({text:'לעדכון אמצעי תשלום', link: Config.updatePaymentMethodLink});
                subTitle = <>לפני שנמשיך בתהליך, עליך לעדכן את אמצעי התשלום שלך {window.Config.brand_Name_HE} </>;
            };
            btnText = 'לאיזור אישי';
            id = props.typePage;
            break;
        case 'ACTION_CANNOT_BE_PERFORMED_THIS_TIME_3':
            imgUrl = ExclamationMark;
            title = <>מצטערים, כרגע לא ניתן לבצע<br></br> את הפעולה שביקשת</>;
            callbackTitle = <>נשמח לסייע לך</>;
            callBackButtons = [{text:'תתקשרו אלי', type: 'CALLBACK'}, {text:`חייגו ${SUPPORT_PHONE} לנציג שירות`, type: 'CALL'}];
            btnText = 'לאיזור אישי';
            id = props.typePage;
            break;
        case 'CANNOT_CONNECT_FIBER_013_PAGE_4':
            imgUrl = ExclamationMark;
            title = <>מצטערים, לא ניתן להתחבר לסיבים עם משתמש של  <span style={{ direction: 'ltr', display: 'inline-block' }}>
            013.net
          </span></>;
            callbackTitle = <>נשמח לסייע לך</>;
            callBackButtons = [{text:'קבלת שיחה חוזרת מנציג', type: 'CALLBACK'}, {text:`חייגו ${SUPPORT_PHONE} לנציג שירות`, type: 'CALL'}];
            btnText = 'לאיזור אישי';
            id = props.typePage;
            break;
        case 'REGIONAL_ISSUE_PAGE_5_2':
            imgUrl = ExclamationMark;
            title = <>קיימת תקלה אזורית / <br></br>עבודות תשתית</>;
            subTitle = <>קיימת תקלה אזורית / עבודות תשתית ברחוב <br></br>{props.fullAddress}<br></br>בעמוד הבא אפשר להתעדכן בצפי התיקון<br></br> ופתרונות זמניים</>
            btnText = 'מעבר לבדיקת הסטטוס';
            id = props.typePage;
            isPurpleButton = true;
            break;
        case 'CONTACT_FOR_SUPPORT_6':
            imgUrl = ExclamationMark;
            title = <>יש לפנות לתמיכה להמשך קבלת העזרה</>;
            subTitle = <> לפני פניה לתמיכה טכנית כדאי לבצע ניתוק <br></br>והפעלה מחדש לנתב</>;
            callBackButtons = [{text:'תתקשרו אלי', type: 'CALLBACK'}, {text:`להתקשר עכשיו ${SUPPORT_PHONE}`, type: 'CALL'}];
            btnText = 'לאיזור האישי';
            id = props.typePage;
            break;
        case 'CONNECTION_NOT_CORRECT':
            imgUrl = ExclamationMark;
            title = <>עוצמת החיבור אינה תקינה</>;
            subTitle = <>לפי הבדיקה שעשינו, עוצמת החיבור אינה תקינה<br></br> ביחס לחבילת האינטרנט שלך. <br></br>יש לתאם ביקור טכנאי</>;
            btnText = 'לתיאום טכנאי';
            isPurpleButton= true;
            id = props.typePage;
            break;
        case 'CONNECTION_FIXED_NOT_CORRECT_9_2_3':
            imgUrl = ExclamationMark;
            title = <>נסיון תיקון החיבור נכשל</>;
            subTitle = <>ביצענו מספר בדיקות ונסיונות לתקן את החיבור שלא צלחו, יש להזמין טכנאי לפתירת הבעיה</>;
            btnText = 'לתיאום טכנאי';
            isPurpleButton= true;
            id = props.typePage;
            break;
        case 'SUPPORT_FURTHER_ASSISTANCE':
            imgUrl = ExclamationMark;
            title = <>יש לפנות לתמיכה טכנית</>;
            callbackTitle = <>נשמח לסייע לך</>;
            callBackButtons = [{text:'תתקשרו אלי', type: 'CALLBACK'}, {text:`חייגו ${SUPPORT_PHONE} לנציג שירות`, type: 'CALL'}];
            btnText = 'לאיזור האישי';
            id = props.typePage;
            break;
        case 'ROUTER_IS_PLUGGED_8_3':
            imgUrl = ExclamationMark;
            title = <> האם הנתב מחובר לחשמל?</>;
            subTitle = <>הנתב צריך להיות מחובר עם הכבל לשקע, וכפתור הפעלת הנתב נמצא במצב On. </>;
            callbackTitle = <>אם הבעיה לא נפתרה, נשמח לסייע לך</>;
            callBackButtons = [{text:'תתקשרו אלי', type: 'CALLBACK'}, {text:`חייגו ${SUPPORT_PHONE} לנציג שירות`, type: 'CALL'}];
            btnText = 'לאיזור האישי';
            id = props.typePage;
            break;
        case 'WRONG_REQUESTED_CANNOT_BE_PERFORMED_12_1_3':
            imgUrl = ExclamationMark;
            title = <>מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת</>;
            callbackTitle = <>נשמח לסייע לך</>;
            callBackButtons = [{text:'תתקשרו אלי', type: 'CALLBACK'}, {text:`חייגו ${SUPPORT_PHONE} לנציג שירות`, type: 'CALL'}];
            btnText = 'לאיזור האישי';
            id = props.typePage;
            break;
        case 'NOT_POSSIBLE_SCHEDULE_TECHNICIAN_12_3':
            imgUrl = ExclamationMark;
            title = <>מצטערים, כרגע לא ניתן לבצע תיאום לטכנאי</>;
            subTitle = <>באפשרותך לנסות שוב או לפנות לשירות הלקוחות</>;
            callBackButtons = [{text:'תתקשרו אלי', type: 'CALLBACK'}, {text:`חייגו ${SUPPORT_PHONE} לנציג שירות`, type: 'CALL'}];
            btnText = 'לאיזור האישי';
            id = props.typePage;
            break;
        case 'TECHNICIAN_COORDINATED_12_2':
            imgUrl = ExclamationMark;
            title = <>ראינו שכבר יש לכם טכנאי מתואם
            ב-{props.serviceVisit?.date} בשעה {props.serviceVisit?.time}</>;
            callbackTitle = <>נשמח לסייע לך</>;
            callBackButtons = [{text:'תתקשרו אלי', type: 'CALLBACK'}, {text:`חייגו ${SUPPORT_PHONE} לנציג שירות`, type: 'CALL'}];
            btnText = 'לאיזור האישי';
            id = props.typePage;
            break;
        case 'HAS_DELIVERY_POWER_SUPPLY':
            const deliveryDate = props.delivery?.DeliverySlots?.[0];
            imgUrl = PowerSupplyIcon;
            title = <>קיימת בעיה בספק כוח,<br/>אנחנו רואים שאחד חדש בדרך אליך!</>;
            subTitle = <>השליח יגיע ביום {deliveryDate.day} {deliveryDate?.date}<br/>
            בין {deliveryDate?.start}-{deliveryDate?.end}<br/>
            ל{props.delivery.fullAddress}</>;
            alert = 'בזמן ביקור השליח, חייב להיות בבית מבוגר מעל גיל 18';
            btnText = 'סיום';
            id = props.typePage;
            break;
        case 'DELIVERY_POWER_SUPPLY_ERROR':
            imgUrl = ExclamationMark;
            title = <>מצטערים, משהו השתבש ולא<br/> הצלחנו לתאם את הגעת השליח</>;
            callbackTitle = <>נשמח לסייע לך</>;
            callBackButtons = [{text:'תתקשרו אלי', type: 'CALLBACK'}];
            btnText = 'לאיזור האישי';
            id = props.typePage;
            break;
        case 'GENERAL_ERROR':
            imgUrl = ExclamationMark;
            title = <>יש לפנות לתמיכה להמשך קבלת העזרה</>;
            callbackTitle = <>נשמח לסייע לך</>;
            callBackButtons = [{text:'קבלת שיחה חוזרת מנציג', type: 'CALLBACK'}, {text:`חייגו ${SUPPORT_PHONE} לנציג שירות`, type: 'CALL'}];
            btnText = 'לאיזור אישי';
            id = props.typePage;
            break;

}

    function handleOnContinue(item) {
        switch (item) {
            case 'NO_INTERNET_SERVICE_PAGE':
                EpiContext.navigateTo(Config.lobbyUrl);
                break;
            case 'ACTION_CANNOT_BE_COMPLETED_PAGE_2_1':
                EpiContext.navigateTo(Config.lobbyUrl);
                break;
            case 'ACTION_CANNOT_BE_PERFORMED_THIS_TIME_3':
                EpiContext.navigateTo(Config.lobbyUrl);
                break;
            case 'CANNOT_CONNECT_FIBER_013_PAGE_4':
                EpiContext.navigateTo(Config.lobbyUrl);
                break;
            case 'REGIONAL_ISSUE_PAGE_5_2':
                EpiContext.navigateTo(props.buttonRegionalIssue);
                break;
            case 'CONTACT_FOR_SUPPORT_6':
                EpiContext.navigateTo(Config.lobbyUrl);
                break;
            case 'CONNECTION_NOT_CORRECT':
                props.getTimeSlotsAsync();
                break;
            case 'CONNECTION_FIXED_NOT_CORRECT_9_2_3':
                props.getTimeSlotsAsync();
                break;
            case 'CONTSCT_SUPPORT_FURTHER_ASSISTANCE':
                EpiContext.navigateTo(Config.lobbyUrl);
                break;
            case 'HAPPY_TO_HELP':
                EpiContext.navigateTo(Config.lobbyUrl);
                break;
            case 'ROUTER_IS_PLUGGED_8_3':
                EpiContext.navigateTo(Config.lobbyUrl);
                break;
            case 'WRONG_REQUESTED_CANNOT_BE_PERFORMED_12_1_3':
                EpiContext.navigateTo(Config.lobbyUrl);
                break;
            case 'NOT_POSSIBLE_SCHEDULE_TECHNICIAN_12_3':
                EpiContext.navigateTo(Config.lobbyUrl);
                break;
            case 'TECHNICIAN_COORDINATED_12_2':
                EpiContext.navigateTo(Config.lobbyUrl);
                break;
            case 'CONNECTION_STRENGTH_IS_NOT_CORRECT_9_1_1':
                props.getTimeSlotsAsync();
                break;
            case 'HAS_DELIVERY_POWER_SUPPLY': //NOT IN USE
                EpiContext.navigateTo(Config.lobbyUrl);
                break;
            case 'DELIVERY_POWER_SUPPLY_ERROR':
                EpiContext.navigateTo(Config.lobbyUrl);
                break;
            case 'GENERAL_ERROR':
                EpiContext.navigateTo(Config.lobbyUrl);
                break;
            default:
                break;
        };
        props.reportDWH({ actionType: 'Error Screen', status: 'Error', messageText: 'General Error', param1: 'InternetFaultWizard' });
    };

    const handleLinkContact = (type, event) => {
      event.preventDefault();
      switch (type) {
        case 'CALLBACK':
            props.goToPage({page: 'numberToReturnPage', typePage: '' });
            break;
        default:
            break;
      }
    };

    const handleLink = (link, event) => {
      event.preventDefault();
      EpiContext.navigateTo(link);
    };

    return (
        <div className={ `error-page-service-request page-wrapper`}>
            <div className='content'>
                <div className='img-error'>
                    <Image src={imgUrl} alt='icon' />
                </div>
                {title && <div className='page-title'> {title} </div>}
                {subTitle && <div className='page-sub-title'> {subTitle} </div>}
                {alert && <div className='alert'><Image src={lightIcon} alt='alert' /> {alert} </div>}
                {dateLinks && dateLinks.length >= 1 &&
                  <div className='links-wrapper'>
                      {dateLinks.map((item,i)=>(
                        <a href='#' onClick={(e) => handleLink(item.link, e)} key={i}>{item.text}</a>
                      ))}
                  </div>
                }
                {callBackButtons.length >= 1 &&
                    <div className='callback-wrapper'>
                        <div className='callback-title'> {callbackTitle}</div>
                        <div className='callback-buttons-wrapper'>
                            {callBackButtons.map((item, i) => {
                                return item.type === 'CALL' ?
                                <div className='call-link' key={i} >
                                    <a href={`tel:${SUPPORT_PHONE}`}
                                      onClick={(e) => handleLinkContact(item.type, e)} key={i}>{item.text}
                                    </a>
                                </div> :
                                <button className='callback-btn' key={i} onClick={(e) => handleLinkContact(item.type, e)} key={i}>{item.text}</button>
                            })}
                        </div>
                    </div>
                }
            </div>
            <div className='button-wrapper'>
                <BtnSubmit
                    isBusiness={false}
                    text={btnText}
                    formid='error-page'
                    isDisplayArrows={false}
                    onclick={() => handleOnContinue(id)}
                    className={isPurpleButton ? 'purple-button' : 'white-button'}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        typePage: state.serviceAppointmentSchedulerBlock.typePage,
        subscriber: state.serviceAppointmentSchedulerBlock.subscriber,
        buttonRegionalIssue: state.serviceAppointmentSchedulerBlock.dataEpi.buttonRegionalIssue,
        serviceVisit: state.serviceAppointmentSchedulerBlock.technicianPage.serviceVisit,
        fullAddress: state.serviceAppointmentSchedulerBlock.subscriber?.address?.fullAddress,
        delivery: state.serviceAppointmentSchedulerBlock.delivery
    };
};

const mapDispatchToProps = { getTimeSlotsAsync, goToPage, reportDWH };

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);
